'use client';

import { useEffect, useRef } from 'react';

/**
 * Closes the popover on a press into the carousel that holds its trigger. Radix Popover dismisses
 * only on the click that follows the press, which the carousel swallows at the end of a drag and a
 * swipe never fires. Outside a carousel the press stays with Radix: on touch it also starts every
 * page scroll, which must not close the popover.
 */
export const useCloseOnPressInCarousel = (
  isOpen: boolean,
  onOpenChange: (open: boolean) => void,
) => {
  const triggerRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const carousel = triggerRef.current?.closest('[data-carousel]');
    if (!isOpen || !carousel) return undefined;
    const closeOnPressBesideTrigger = (event: Event) => {
      if (!triggerRef.current?.contains(event.target as Node)) {
        onOpenChange(false);
      }
    };
    carousel.addEventListener('pointerdown', closeOnPressBesideTrigger);
    return () => carousel.removeEventListener('pointerdown', closeOnPressBesideTrigger);
  }, [isOpen, onOpenChange]);

  return triggerRef;
};
